/*
 * @Author       : yilei
 * @Date         : 2023-01-31 17:38:16
 * @LastEditTime : 2023-02-19 16:31:39
 * @LastEditors  : yilei
 */
/**
 * @description: 获取路由上的某一个参数
 * @param {string} name 参数名
 * @return {*} 参数值
 */
export const getQuery = (name: string) => {
  let result = ''
  const reg = new RegExp(''.concat(name, '=[a-zA-Z0-9]+'))
  const arr = location.href.match(reg) || []
  if (arr.length > 0) {
    result = arr[0].split('=')[1]
  } else {
    result = ''
  }
  return result === 'NaN' ? '' : result
}

export const getCookie = (key: string) => {
  const reg = new RegExp('(^| )'.concat(key, '=([^;]*)(;|$)'))
  const arr = document.cookie.match(reg)

  if (arr) {
    return unescape(arr[2])
  }

  return null
}

export const delay = (ms: number) => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
